import type { ReactNode } from "react";
import { KonstaProvider } from "@/components/konsta";

type MobileUiProviderProps = {
  children: ReactNode;
};

const MobileUiProvider = ({ children }: MobileUiProviderProps) => {
  return <KonstaProvider>{children}</KonstaProvider>;
};

export default MobileUiProvider;
